// src/components/YoutubeSection.js

import React from 'react';
import './YoutubeSection.css';
import { FiYoutube } from 'react-icons/fi';

const YoutubeSection = () => {
    // ID del video Short: https://youtube.com/shorts/JnbQFJudKxA
    const videoId = 'JnbQFJudKxA';
    const channelUrl = 'https://www.youtube.com/@GiovanniScarvaciYAsociados'; // Asume esta es la URL real del canal

    return (
        <section id="youtube-sub" className="section youtube-container">
            <h2><FiYoutube /> Suscríbete a Nuestro Canal de YouTube</h2>
            <p>Mira nuestro último corto: Asesoría especializada para profesionales del Derecho.</p>
            
            <div className="youtube-content">
                <div className="video-responsive">
                    {/* Embed del YouTube Short (Formato Vertical) */}
                    <iframe 
                        width="300" 
                        height="533" 
                        src={`https://www.youtube.com/embed/${videoId}?controls=0`} 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerPolicy="strict-origin-when-cross-origin" 
                        allowFullScreen>
                    </iframe>
                </div>
                
                <div className="youtube-cta">
                    <p>En nuestro canal, exploramos temas de Derecho, Economía y Valoración de activos. ¡No te lo pierdas!</p>
                    <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="cta-button primary youtube-button">
                        <FiYoutube style={{marginRight: '5px'}} /> Suscribirse Ahora
                    </a>
                </div>
            </div>
        </section>
    );
};

export default YoutubeSection;